// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__WDMJR","content":"ManualTimeModal_content__3IXLx"};